export enum CourtSide {
    DEUCE = "DEUCE",
    AD = "AD"
}